/* eslint-disable no-undef */
import { DateTime } from 'luxon';

WB.Utility = WB.Utility || {};

WB.Utility.DataManagerUtility = function($log, _Config) {

    this.CacheStores = {};

    this.getExpiryTime = function(expiryKey) {
        if (!expiryKey) {
            return null;
        }
        if (expiryKey === true) {
            // Create a DateTime object representing the current date and time, and subtract 1 second from it and convert resulting date to JS date object
            const currentDateTimeMinusSecond = DateTime.now().minus({ seconds: 1 }).toJSDate();
            return currentDateTimeMinusSecond;
        }

        // Create a DateTime object representing the current date and time, and add (_Config.PollingTimes[expiryKey] - 5) to it and convert resulting date to JS date object.
        const currentDateTimePlusPollingTime = DateTime.now().plus({ seconds: _Config.PollingTimes[expiryKey] - 5 }).toJSDate();
        return currentDateTimePlusPollingTime;
    };

    this.SetCache = function(options) {
        this.CacheStores[options.name] = this.CacheStores[options.name] || {};

        if (this.CacheStores[options.name][options.signature]) {
            this.CacheStores[options.name][options.signature].value = options.value;
            this.CacheStores[options.name][options.signature].expires = this.getExpiryTime(options.expiryKey);

            $log.debug('Overriding [%s] cache with signature [%s]. Expires at [%s].', options.name, options.signature, this.CacheStores[options.name][options.signature].expires);

            if (options.updatedCb) {
                options.updatedCb(options.value);
            }
        } else {
            this.CacheStores[options.name][options.signature] = {
                value: options.value,
                expires: this.getExpiryTime(options.expiryKey)
            };
            $log.debug('Adding to [%s] cache with signature [%s]. Expires at [%s].', options.name, options.signature, this.CacheStores[options.name][options.signature].expires);
            if (options.createdCb) {
                options.createdCb(options.value);
            }
        }
    };

    this.GetCache = function(options) {
        var store = this.CacheStores[options.name] || {};
        if (store[options.signature]) {
            const currentJSDateNow = DateTime.now().toJSDate();
            const isExpired = store[options.signature].expires && currentJSDateNow >= store[options.signature].expires;
            if (isExpired) {
                $log.debug('[%s] cache with signature [%s] expired.', options.name, options.signature);
                return null;
            }
            $log.debug('Retrieving from [%s] cache with signature [%s].', options.name, options.signature);
            return store[options.signature].value;
        }
        return null;
    };

    this.ClearCache = function(options) {
        $log.debug('Deleting [%s] cache with signature [%s].', options.name, options.signature);
        var store = this.CacheStores[options.name] || {};
        delete store[options.signature];
    };

};
WB.Utility.DataManagerUtility.$inject = ['$log', '_Config'];

WB.Core.service('DataManagerUtility', WB.Utility.DataManagerUtility);
